module.exports = __webpack_public_path__ + "static/media/help-block.1a96d586.png";